import React from 'react';
import LiveChatPage from '../../live-chat/pages/LiveChatPage';

const AgentAdminLiveChatPage = ({ session = {} }) => (
  <LiveChatPage session={session} mode="agentAdmin" />
);

export default AgentAdminLiveChatPage;
